import { render } from "./AllSinglenews.vue?vue&type=template&id=ff2cb420&scoped=true"
import script from "./AllSinglenews.vue?vue&type=script&lang=js"
export * from "./AllSinglenews.vue?vue&type=script&lang=js"

import "./AllSinglenews.vue?vue&type=style&index=0&id=ff2cb420&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff2cb420"]])

export default __exports__